import { render, staticRenderFns } from "./IndicatorGroupForm.vue?vue&type=template&id=bec9d6c2&scoped=true&"
import script from "./IndicatorGroupForm.vue?vue&type=script&lang=js&"
export * from "./IndicatorGroupForm.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorGroupForm.vue?vue&type=style&index=0&id=bec9d6c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec9d6c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDialog,VIcon,VTextField})
